/* eslint-disable no-mixed-spaces-and-tabs, prettier/prettier */

import Config from './config.env.js';

export default Config;